import React from 'react'
import { useTranslation } from 'react-i18next'

export const FormErrors = ({ meta }: any) => {
    const { t } = useTranslation()

    return (
        <div className='form-error-msg'>
            {meta.touched && meta.error ? (
                meta.error.key
                    ? <small>{t(meta.error.key, (meta.error.options as {}) || {})}</small>
                    : <small>{meta.error}</small>
            ) : null}
        </div>
    )
}
